import { makeStyles } from "@material-ui/styles";
import React from "react";
import { LinearProgress } from "@material-ui/core";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/rootReducer";

interface PlannerTimelineLoadingProps {
}

const useStyles = makeStyles((theme) => ({
    loading: {
        width: "100%",
        "& > * + *": {
            marginTop: 16,
        },
    }
}));


const PlannerTimelineLoading: React.FC<PlannerTimelineLoadingProps> = () => {
    const classes = useStyles();
    const { plannerLoadingStore } = useSelector((state: RootState) => state);
    return (
        <>
            {plannerLoadingStore.loading ? (
                <div className={classes.loading}>
                    <LinearProgress color="primary" />
                </div>
            ) : null}
        </>
    );
};
export default PlannerTimelineLoading;
